// extracted by mini-css-extract-plugin
export default {"scanAddModalBody":"scanAddModalBody___NwRUK","activeRecord":"activeRecord___BtXsa","ellipsis":"ellipsis___JFJwf","titleParent":"titleParent___wcaK3"};